// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1xfX9","boxTitle":"Qualiphy_boxTitle__2MWG2","box":"Qualiphy_box__2Yj5s","toggleWrap":"Qualiphy_toggleWrap__25lxb"};